interface PartnerImageLogos {
  src: string;
  alt: string;
}

export const partnerImages: PartnerImageLogos[] = [
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/mckesson-logo.3715939.svg',
    alt: 'McKesson logo',
  },
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/aig-logo.731c6fb.svg',
    alt: 'AIG logo',
  },
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/ibm-logo.19EF9C80.svg',
    alt: 'IBM logo',
  },
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/scotiabank-logo.E20E85E8.svg',
    alt: 'Scotiabank logo',
  },
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/rbc-logo.029a61f.svg',
    alt: 'RBC logo',
  },
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/bmo-logo.F845A0BE.svg',
    alt: 'BMO logo',
  },
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/nike-logo.F4406519.svg',
    alt: 'Nike logo',
  },
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/pepsico-logo.bb6c8f.svg',
    alt: 'Pepsico logo',
  },
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/cf-logo.FEB98716.svg',
    alt: 'CF logo',
  },
  {
    src: '//storage.googleapis.com/ttc-static-images/landing/edelman-logo.47084f.svg',
    alt: 'Edelman logo',
  },
];
